var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grid-container fluid mt-3"},[_c('OrderForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }